<div class="modal-body" style="font-weight:bold;color:red;">
  {{data?.title }}
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" [mat-dialog-close]="false">{{'Cancel'}}</button>
  <button type="button" class="btn btn-primary" [mat-dialog-close]="true">{{'OK'}}</button>
</div>

